module.exports = __webpack_public_path__ + "staticmobile/img/audit_bg.75eb7e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audit_bg.jpg
// module id = 6/Iw
// module chunks = 0